import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './BuilderChatPhone.css';

export interface IBuilderChatPhoneProps {
  phone: string;
}

export const BuilderChatPhone: React.FC<IBuilderChatPhoneProps> = ({ phone }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <IconCommunicationPhone16 color="icon-on-bright-disabled" />
      </div>

      <UIHeading4>{phone}</UIHeading4>
    </div>
  );
};
